// import Business from '../Sellpoint/Template/index.vue' //BusinessView
// import Settings from '../Settings/index.vue' //SeetingsView
// import Refer from '../Refer/index.vue' //ReferView
// import Help from '../Help/index.vue' //HelpView
//
import Account from '../Resources/script.js' //scripts


export default {
    name: 'Account',
    mixins: [Account],
    data () {
        return {
            sps:{},
            can_multiple_shops:true,
            can_show_footer:true,
        }
    },

    components: {
        // 'business-view': Business,
        // 'settings': Settings,
        // 'help-view': Help,
        // 'refer-view': Refer,
    },
     
    methods: {

        back(){
            window.history.back(); 
        },

        setSP(sp){
            this.$store.dispatch('account/userAccountBusiness',sp);
            this.$router.push('/dashboard/business');
        },

        routeToPage(page){
            this.$router.push(page);
            this.set_menu = false;
        },

        canShowFooter(){console.log('lo....'+this.$route.name)
            if(this.$route.name == 'Sellpoint'){
                this.can_show_footer = false;
            }
        }
      
    },

    mounted: function() {
        this.canShowFooter();
    },

    created: function(){
        //this.loading = true;
        let self = this;
        //setTimeout(function(){ self.setSP(); }, 1000); //wait for 3sec 
        //setTimeout(function(){ self.setSellpoint(); }, 3000); //wait for 3sec 
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Template/script.js